





















import { TaskUserCommitsItem } from '@/api';
import Vue, { PropType } from 'vue';
import { isEmpty } from 'lodash-es';
import { TaskFile } from '@/views/taskFile/types';
import StructureTree from './structure-tree.vue';
import AppControlWander from './control-wander.vue';
// import AppControlMeasure from './control-measure.vue';
import ModelNotion from './model-notation.vue';

export interface TreeItem {
    name: string;
    height?: number;
    instanceIds?: number[];
    children?: TreeItem[];
}
export default Vue.extend({
    components: { StructureTree, AppControlWander, ModelNotion },
    // fileId = commit.uploadFile.fileId
    props: {
        commit: { type: Object as PropType<TaskUserCommitsItem> },
        spdApi: { type: Object },
        spdParams: { type: Object },
        api: { type: Object },
        isFold: { type: Boolean },
        file: { type: Object as PropType<TaskFile> },
        tree: { type: Array as PropType<TreeItem[]> },
    },
    computed: {
        isCommit() {
            return !isEmpty(this.commit);
        },
    },
    data() {
        return {
            activeName: 'structureTree' as 'structureTree' | 'modelNotation' | 'measurement' | 'roam',
        };
    },
    methods: {
        handleClick(tab, event) {
            console.log(tab, event);
        },
    },
});
